import ENV from "config/Env";
import { typedQueryClient, useTypedMutation } from "hooks";
import { TYRE_SOURCES } from "models";
import { TyresDashboardQueryKeys } from "modules/TyresDashboard/queryKeys";
import { ApiInstance } from "utils/Api";
import { toISOString } from "utils/dateHelperFunctions";

import type { Tyre, TyreID } from "models";

export type TyreFormPayload = Pick<
  Tyre,
  "id" | "manufacturer" | "description" | "carry_capacity" | "width" | "height" | "size" | "speed" | "season" | "ean" | "run_flat_tire"
>;

export const useCreateTyreMutation = () =>
  useTypedMutation<TyreFormPayload, TyreID>({
    mutationFn: async payload => (await ApiInstance.post("/tyres/create", payload, ENV.carBaseURL)).data.tyre_id,
    onSuccess: (payload, tyreId) => {
      const tyres = typedQueryClient.getQueryData(TyresDashboardQueryKeys.tyres);
      if (!tyres) return;

      const now = toISOString(new Date());
      const createdTyre = { ...payload, id: tyreId, created_on: now, updated_on: now, deleted: false, created_by_id: null, created_source: TYRE_SOURCES.User };

      typedQueryClient.setQueryData(TyresDashboardQueryKeys.tyres, {
        ...tyres,
        nb_items: tyres.nb_items + 1,
        items: [createdTyre, ...(tyres.items ?? [])]
      });
    }
  });
